export interface LoginLogDto {
  readonly Username: string;
  readonly UserId: number | null;
  readonly Email: string;
  readonly Ip: string;
  readonly DeviceName: string; // <-- Αλλαγή από PcName σε DeviceName
  readonly DeviceUserName: string; // <-- Αλλαγή από PcUserName σε DeviceUserName
  readonly UserAgent: string;
  readonly Date: string;
  readonly Time: string;
  readonly Succesful: boolean;
  readonly FailureReason: string;
}

export interface LoginLogFieldDefinition {
  readonly name: keyof LoginLogDto;
  readonly label: string;
  readonly type: "number" | "date" | "string" | "boolean";
  readonly required: boolean;
}

export const loginLogFields: readonly LoginLogFieldDefinition[] = [
  { name: "Username", label: "Όνομα Χρήστη", type: "string", required: true },
  {
    name: "Date",
    label: "Ημερομηνία",
    type: "date",
    required: true,
  },
    {
    name: "Time",
    label: "Ώρα",
    type: "date",
    required: true,
  },
    { name: "Ip", label: "IP", type: "string", required: true },
     { name: "UserAgent", label: "User Agent", type: "string", required: true },
{
    name: "DeviceName",
    label: "Όνομα Συσκευής",
    type: "string",
    required: true,
  }, // <-- Αντίστοιχη αλλαγή στο label/name
  {
    name: "DeviceUserName",
    label: "Χρήστης Συσκευής",
    type: "string",
    required: true,
  }, // <-- Αντίστοιχη αλλαγή στο label/name
  { name: "Email", label: "Email", type: "string", required: true },

  { name: "Succesful", label: "Επιτυχές", type: "boolean", required: true },
  {
    name: "FailureReason",
    label: "Αιτία Αποτυχίας",
    type: "string",
    required: false,
  },
] as const;

export const loginLogFilters = loginLogFields.filter((f) =>
  ["Username", "Email", "Ip", "DateTimeStamp", "Succesful"].includes(f.name),
);
